import React from 'react'

const Navbar = () => {
  return (
    <div
    className=' text-white text-3xl flex pl-3 justify-center sm:justify-normal  items-center text-center font-bold sm:text-left w-full h-[8vh] bg-gray-900'
    >ZipCode Tracker</div>
  )
}

export default Navbar